/**
 * Shared helpers for a single column-filter VALUE object (`{ range }`,
 * `{ values }`, `{ text }`, `{ keywords, mode }`, or a combined location value).
 *
 * Extracted from ColumnFilterPopover so the column-header popover and the
 * Add-filter panel share one draft/commit rule — both clone the committed value
 * into a local draft, edit it, and treat an "empty" draft as a clear.
 */

/**
 * Shallow-clone a filter value, preserving its Set fields (Sets aren't
 * structuredClone-safe on older runtimes and we want a stable draft scope).
 */
export function cloneFilterValue(value) {
  if (value == null) return null;
  const out = {};
  if (value.range) out.range = { ...value.range };
  if (value.values) out.values = new Set(value.values);
  if (value.text != null) out.text = value.text;
  if (value.keywords) out.keywords = new Set(value.keywords);
  if (value.mode) out.mode = value.mode;
  return out;
}

/**
 * True if a filter value carries no active sub-condition — committing it is
 * equivalent to clearing the column.
 */
export function isEmptyFilterValue(value) {
  if (value == null) return true;
  if (value.range && (value.range.min != null || value.range.max != null)) return false;
  if (value.values && value.values.size > 0) return false;
  if (value.text) return false;
  if (value.keywords && value.keywords.size > 0) return false;
  return true;
}
